export enum Environment {
  Prod = 'prod',
  Dev = 'dev',
}
